import { deleteApi, getApi, patchApi, postApi, putApi } from '../../services/api_methods';

export const createProjectApi = (data) => postApi(`/project/create-project`, data);

export const getClientOptionsApi = () => getApi(`/project/get-all-clients`);

export const getEmployeeOptionsApi = () => getApi(`/project/get-all-employees`);
export const getAllAssigneeEmployees = () => getApi(`/project/get-all-assignee-employees`);

export const getProjectsList = (query) => getApi(`/project/get-projects-listing?${query}`);

export const updateProjectApi = (data) => putApi(`/project/update-project`, data);

export const deleteProjectApi = (id) => deleteApi(`/project/delete-project/${id}`);

export const getProjectsLogs = (query) => getApi(`/project/get-project-logs/?${query}`);

export const getProjectGraphApi = (query) => getApi(`/project/get-project-status-counts?${query}`);

export const getProjectDetails = (id) => getApi(`/project/get-project-client-details/${id}`);

export const getProjectTotalBilling = (id) => getApi(`/project/project-billable-mins/${id}`);

export const getProjectDocumentApi = (id) => getApi(`/project/get-all-project-documents/${id}`);

export const deleteProjectDocumentApi = (id) => deleteApi(`/project/delete-project-document/${id}`);

export const addChangeRequestApi = (data) => postApi(`/project/add-change-request-module`, data);

export const getChangeRequestsApi = (id) => getApi(`/project/get-change-request-modules/${id}`);

export const deleteChangeRequestApi = (id) =>
  deleteApi(`/project/delete-change-request-module/${id}`);

export const updateChangeRequestApi = (data, id) =>
  putApi(`/project/update-change-request-module/${id}`, data);

export const getMilestoneList = (id, params) =>
  getApi(`/project/get-project-milestones/${id}?${params}`);

export const deleteMilestoneApi = (id) => deleteApi(`/project/delete-project-milestone/${id}`);

export const addMilestoneApi = (data) => postApi(`/project/add-project-milestone`, data);

export const updateMilestoneApi = (data, id) =>
  putApi(`/project/update-project-milestone/${id}`, data);

export const updateProjectInchargeApi = (data, id) =>
  putApi(`/project/update-project-incharge/${id}`, data);

export const updateProjectTeamApi = (data, id) =>
  putApi(`/project/update-team-members/${id}`, data);

export const getAllMembersProject = (id) => getApi(`/project/getAllMemberOfProject/${id}`);

export const getProjectOptionsApi = (query) => getApi(`/project/getAllProjects?${query}`);

export const updateProjectManagerApi = (data, id) =>
  putApi(`/project/update-project-manager/${id}`, data);

export const getProjectSourcesApi = (query) => getApi(`/psid/get-project-sources?${query}`);

export const updateProjectBillingDataApi = (id, data) =>
  patchApi(`/psid/update-project-billing-data/${id}`, data);

export const updateProjectStatusApi = (payload) =>
  postApi(`/project/update-project-status`, payload);

export const getProjectRemarksApi = (id, params) =>
  getApi(`/project/get-project-remarks/${id}?${params}`);

export const addProjectRemarksApi = (id, payload) =>
  postApi(`/project/add-project-remarks/${id}`, payload);

export const updateProjectRemarksApi = (id, payload) =>
  putApi(`/project/edit-project-remarks/${id}`, payload);

export const deleteProjectRemarksApi = (id) => deleteApi(`/project/delete-project-remarks/${id}`);

export const addProjectFeedbackApi = (payload) => postApi(`/project/add-project-notes`, payload);

export const updateProjectFeedbackApi = (payload) =>
  putApi(`/project/update-project-notes`, payload);

export const deleteProjectFeedbackApi = (id) => deleteApi(`/project/delete-project-notes/${id}`);

export const getProjectFeedbackApi = (id, params) =>
  getApi(`/project/get-project-notes/${id}?${params}`);
